import React from 'react';

export const netLeavesTooltip = {
    body: (
        <span>
            The total value of (Sells + Shorts) - Buys expressed in currency
            units. Net Leaves can be changed to be calculated as Buys - (Sells +
            Shorts) in the settings.
        </span>
    ),
};

export const buyLeavesTooltip = {
    body: (
        <span>
            The total value of Buy residuals expressed in currency units.
        </span>
    ),
};

export const sellLeavesTooltip = {
    body: (
        <span>
            The total value of Sell residuals expressed in currency units.
        </span>
    ),
};
